var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconViewcrosshair = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 9.25C17.786 9.25 20.25 11.714 20.25 14.75C20.25 17.786 17.786 20.25 14.75 20.25C11.714 20.25 9.25 17.786 9.25 14.75C9.25 11.714 11.714 9.25 14.75 9.25ZM14.75 10.75C12.54 10.75 10.75 12.54 10.75 14.75C10.75 16.96 12.54 18.75 14.75 18.75C16.96 18.75 18.75 16.96 18.75 14.75C18.75 12.54 16.96 10.75 14.75 10.75Z",
  fill: "#7F7F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14H23V15.5H15.5V23H14V15.5H1V14H14V1H15.5V14Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconViewcrosshair);
export { ForwardRef as ReactComponent };